import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
    const { t } = useTranslation();

    return (
        <div className="container text-center py-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="card-body p-5">
                            <h1 className="display-4 text-danger mb-4">
                                <i className="fas fa-exclamation-triangle me-3"></i>
                                {t('Unauthorized Access')}
                            </h1>
                            <p className="lead mb-4">
                                {t("You don't have permission to access this page. This area is restricted to authorized users only.")}
                            </p>
                            <Link to="/" className="btn btn-primary btn-lg">
                                {t('Return to Home')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
